<template>
  <div>
    <a-form :form="form">
      <a-card title="项目基本信息">
        <a-row type="flex" justify="space-between" align="top">
          <a-col :span="11">
            <a-form-item label="项目名称">
              <a-input v-decorator="['xmname', validatorRules.name]" placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="项目编号">
              <a-input v-decorator="['number', validatorRules.name]" placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="项目类别">
              <a-select placeholder="请选择">
                <a-select-option value="jack"> Jack </a-select-option>
                <a-select-option value="lucy"> Lucy </a-select-option>
                <a-select-option value="disabled" disabled> Disabled </a-select-option>
                <a-select-option value="Yiminghe"> yiminghe </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="发布单位">
              <a-input disabled placeholder="自动读取"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="项目发布人">
              <a-input disabled placeholder="自动读取"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="专项资金（万元）">
              <a-input placeholder="00.00"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="其他来源资金（万元）">
              <a-input placeholder="00.00"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="总预算（万元）">
              <a-input placeholder="自动计算"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="项目周期">
              <a-range-picker style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="实施周期（月）">
              <a-input placeholder="自动计算"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="里程碑考核节点">
              <a-date-picker style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="关联的指南">
              <a-select placeholder="请选择">
                <a-select-option value="jack"> Jack </a-select-option>
                <a-select-option value="lucy"> Lucy </a-select-option>
                <a-select-option value="disabled" disabled> Disabled </a-select-option>
                <a-select-option value="Yiminghe"> yiminghe </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="关联的科技需求">
              <a-select placeholder="请选择">
                <a-select-option value="jack"> Jack </a-select-option>
                <a-select-option value="lucy"> Lucy </a-select-option>
                <a-select-option value="disabled" disabled> Disabled </a-select-option>
                <a-select-option value="Yiminghe"> yiminghe </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="关注的话题（可多选）">
              <a-select mode="multiple" placeholder="请选择">
                <a-select-option value="jack"> Jack </a-select-option>
                <a-select-option value="lucy"> Lucy </a-select-option>
                <a-select-option value="disabled" disabled> Disabled </a-select-option>
                <a-select-option value="Yiminghe"> yiminghe </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="固定的关键词（可多选）">
              <a-select mode="multiple" placeholder="请选择">
                <a-select-option value="jack"> Jack </a-select-option>
                <a-select-option value="lucy"> Lucy </a-select-option>
                <a-select-option value="disabled" disabled> Disabled </a-select-option>
                <a-select-option value="Yiminghe"> yiminghe </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="自设关键词（可输入多个字段，“；”分割）">
              <a-input placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
      <a-card title="预期成果形式">
        <a-form-item label="预期成果">
          <a-checkbox-group :options="modalityList" @change="onChange" />
          <a-input style="width: 20%" placeholder="请输入"></a-input>
        </a-form-item>
      </a-card>
      <a-card title="项目联系人">
        <a-row type="flex" justify="space-between" align="top">
          <a-col :span="11">
            <a-form-item label="证件信息">
              <a-input-group compact>
                <a-select style="width: 25%" default-value="Zhejiang">
                  <a-select-option value="Zhejiang">消防救援人员证 </a-select-option>
                  <a-select-option value="Jiangsu"> 消防救援人员证 </a-select-option>
                </a-select>
                <a-input style="width: 75%" placeholder="自动识别账号信息" />
              </a-input-group>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="联系人姓名">
              <a-input placeholder="自动识别账号信息"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="所属单位">
              <a-input placeholder="自动识别账号信息"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="联系电话">
              <a-input placeholder="自动识别账号信息"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
      <a-card title="项目负责人信息">
        <a-row type="flex" justify="space-between" align="top">
          <a-col :span="11">
            <a-form-item label="证件信息">
              <a-input-group compact>
                <a-select style="width: 25%" default-value="Zhejiang">
                  <a-select-option value="Zhejiang">消防救援人员证 </a-select-option>
                  <a-select-option value="Jiangsu"> 消防救援人员证 </a-select-option>
                </a-select>
                <a-input style="width: 75%" placeholder="输入账号精确查找用户" />
              </a-input-group>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="所属单位">
              <a-input placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="负责人姓名">
              <a-input placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="负责人性别">
              <a-radio-group name="radioGroup" :default-value="1">
                <a-radio :value="1"> 男 </a-radio>
                <a-radio :value="2"> 女 </a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="负责人联系电话">
              <a-input placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="出生年月">
              <a-date-picker style="width: 100%" placeholder="选择时间" />
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="职务">
              <a-input placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="最高学历">
              <a-select placeholder="请选择">
                <a-select-option value="jack"> Jack </a-select-option>
                <a-select-option value="lucy"> Lucy </a-select-option>
                <a-select-option value="disabled" disabled> Disabled </a-select-option>
                <a-select-option value="Yiminghe"> yiminghe </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="职称">
              <a-select placeholder="请选择">
                <a-select-option value="jack"> Jack </a-select-option>
                <a-select-option value="lucy"> Lucy </a-select-option>
                <a-select-option value="disabled" disabled> Disabled </a-select-option>
                <a-select-option value="Yiminghe"> yiminghe </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="电子邮箱">
              <a-input placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
      <a-card title="项目参与单位">
        <a-button type="primary" icon="plus" @click="addUnit"> 新增参与单位 </a-button>
        <a-table :columns="unitColumns" :data-source="unitData">
          <template slot="name" slot-scope="text, record">
            <a-input placeholder="请输入" v-model="record.name"></a-input>
          </template>
          <template slot="dwlx">
            <a-select placeholder="请选择">
              <a-select-option value="jack"> Jack </a-select-option>
              <a-select-option value="lucy"> Lucy </a-select-option>
              <a-select-option value="disabled" disabled> Disabled </a-select-option>
              <a-select-option value="Yiminghe"> yiminghe </a-select-option>
            </a-select>
          </template>
          <template slot="xydm">
            <a-input placeholder="请输入"></a-input>
          </template>
          <template slot="action" slot-scope="text, record">
            <span @click="onDelete(record.key)" style="color: #1890ff">删除</span>
          </template>
        </a-table>
      </a-card>
      <a-card title="参与人员信息">
        <a-button type="primary" icon="plus" @click="addParticipant"> 新增参与人 </a-button>
        <a-table :columns="participantColumns" :data-source="participantData">
          <template slot="type">
            <a-select placeholder="请选择">
              <a-select-option value="jack"> Jack </a-select-option>
              <a-select-option value="lucy"> Lucy </a-select-option>
              <a-select-option value="disabled" disabled> Disabled </a-select-option>
              <a-select-option value="Yiminghe"> yiminghe </a-select-option>
            </a-select>
          </template>
          <template slot="card">
            <a-input-group compact>
              <a-select style="width: 25%" default-value="Zhejiang">
                <a-select-option value="Zhejiang">消防救援人员证 </a-select-option>
                <a-select-option value="Jiangsu"> 消防救援人员证 </a-select-option>
              </a-select>
              <a-input style="width: 75%" placeholder="输入证件号精确查找用户" />
            </a-input-group>
          </template>
          <template slot="name" slot-scope="text, record">
            <a-input placeholder="请输入" v-model="record.name"></a-input>
          </template>
          <template slot="unit" slot-scope="text, record">
            <a-input placeholder="请输入" v-model="record.name"></a-input>
          </template>
          <template slot="action" slot-scope="text, record">
            <span @click="participantDelete(record.key)" style="color: #1890ff">删除</span>
          </template>
        </a-table>
      </a-card>
      <a-card title="项目摘要">
        <a-form-item label="联系人姓名">
          <a-textarea placeholder="请输入5000字以内的文字"></a-textarea>
        </a-form-item>
      </a-card>
      <a-card title="项目合同">
        <p>附件（附件类型pdf，附件大小不超过3M，不限个数。）</p>
        <a-upload
          name="file"
          :multiple="true"
          listType="text"
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        >
          <a-button> <a-icon type="upload" /> 上传附件 </a-button>
        </a-upload>
      </a-card>
      <a-card title="其他附件">
        <p>附件（附件类型pdf/word/excel，附件大小不超过3M，最多上传5份。）</p>
        <a-upload
          name="file"
          :multiple="true"
          listType="text"
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        >
          <a-button> <a-icon type="upload" /> 上传附件 </a-button>
        </a-upload>
      </a-card>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'Item_Information_Form',
  data() {
    return {
      modalityList: [
        {
          label: '新理论',
          value: 1,
        },
        {
          label: '新原理',
          value: 2,
        },
        {
          label: '新产品',
          value: 3,
        },
        {
          label: '关键部件',
          value: 4,
        },
        {
          label: '软件',
          value: 5,
        },
        {
          label: '应用解决方案',
          value: 6,
        },
        {
          label: '实验装置/系统',
          value: 7,
        },
        {
          label: '工程工艺',
          value: 8,
        },
        {
          label: '标准',
          value: 9,
        },
        {
          label: '论文',
          value: 10,
        },
        {
          label: '专利',
          value: 11,
        },
        {
          label: '研究报告',
          value: 12,
        },
        {
          label: '其他',
          value: 13,
        },
      ],
      form: this.$form.createForm(this, { name: 'coordinated' }),
      validatorRules: {
        name: { rules: [{ required: true, message: '项目名称不能为空' }] },
        number: { rules: [{ required: true, message: '项目编号不能为空' }] },
      },
      unitData: [],
      unitColumns: [
        {
          title: '序号',
          dataIndex: 'serial',
          key: 'serial',
          width: 100,
        },
        {
          title: '单位名称',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '单位类型',
          dataIndex: 'dwlx',
          key: 'dwlx',
          scopedSlots: { customRender: 'dwlx' },
        },
        {
          title: '统一社会信用代码',
          dataIndex: 'xydm',
          key: 'xydm',
          scopedSlots: { customRender: 'xydm' },
        },
        {
          title: '操作',
          dataIndex: '',
          key: 'action',
          width: 80,
          scopedSlots: { customRender: 'action' },
        },
      ],
      participantData: [],
      participantColumns: [
        {
          title: '序号',
          dataIndex: 'serial',
          key: 'serial',
          width: 100,
        },
        {
          title: '参与人类型',
          dataIndex: 'type',
          key: 'type',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: '参与人证件信息',
          dataIndex: 'card',
          key: 'card',
          scopedSlots: { customRender: 'card' },
        },
        {
          title: '参与人姓名',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '参与人所属单位',
          dataIndex: 'unit',
          key: 'unit',
          scopedSlots: { customRender: 'unit' },
        },
        {
          title: '操作',
          dataIndex: '',
          key: 'action',
          width: 80,
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    onChange(e) {
      console.log(e)
    },
    //添加单位
    addUnit() {
      let obj = {
        key: Date.now(),
        serial: this.unitData.length + 1,
        name: '',
        dwlx: '',
        xydm: '',
      }
      this.unitData.push(obj)
      console.log(this.unitData)
    },
    //删除单位
    onDelete(key) {
      let unitData = [...this.unitData]
      this.unitData = unitData.filter((item) => item.key !== key)
      let num = 1
      for (const i of this.unitData) {
        console.log(i)
        i.serial = num
        num++
      }
    },
    //添加参与人
    addParticipant() {
      let obj = {
        key: Date.now(),
        serial: this.participantData.length + 1,
        name: '',
        dwlx: '',
        xydm: '',
      }
      this.participantData.push(obj)
    },
    //删除参与人
    participantDelete(key) {
      let participantData = [...this.participantData]
      this.participantData = participantData.filter((item) => item.key !== key)
      let num = 1
      for (const i of this.participantData) {
        i.serial = num
        num++
      }
    },
  },
}
</script>

<style>
</style>